import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { IWhistleBlowPage } from "../../whistleBlow/whistleBlowPage";
import { TDefaultListFilter } from "../../common/defaultListFilter";

// State
export interface IWhistleBlowPageState {
    dataId: number;
    whistleBlowPage: IWhistleBlowPage;
}

export interface IWhistleBlowListState {
    defaultFilter: TDefaultListFilter;
}

export interface IWhistleBlowState {
    page: IWhistleBlowPageState;
    list: IWhistleBlowListState;
}

// Action type constants
const WHISTLE_BLOW_SUCCESS = "WHISTLE_BLOW_SUCCESS";
const WHISTLE_BLOW_FAILURE = "WHISTLE_BLOW_FAILURE";

const WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER = "WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER";

type T_WHISTLE_BLOW_SUCCESS = typeof WHISTLE_BLOW_SUCCESS;
type T_WHISTLE_BLOW_FAILURE = typeof WHISTLE_BLOW_FAILURE;

type T_WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER = typeof WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER;

// Action types
interface IWhistleBlowSuccess extends Action {
    type: T_WHISTLE_BLOW_SUCCESS;
    whistleBlowPage: IWhistleBlowPage;
}

interface IWhistleBlowFailure extends Action {
    type: T_WHISTLE_BLOW_FAILURE;
}

interface IWhistleBlowListSetDefaultFilter extends Action {
    type: T_WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

export type WhistleBlowAction =
    | IWhistleBlowSuccess
    | IWhistleBlowFailure
    | IWhistleBlowListSetDefaultFilter;

//Actions
export const whistleBlowSuccess = (whistleBlowPage: IWhistleBlowPage): IWhistleBlowSuccess => ({
    type: WHISTLE_BLOW_SUCCESS,
    whistleBlowPage
});

export const whistleBlowFailure = (): IWhistleBlowFailure => ({
    type: WHISTLE_BLOW_FAILURE
});

export const whistleListSetDefaultFilter = (defaultFilter: TDefaultListFilter): IWhistleBlowListSetDefaultFilter => ({
    type: WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const whistleBlowInitialState: IWhistleBlowState = {
    page: {
        dataId: 0,
        whistleBlowPage: null
    },
    list: {
        defaultFilter: null
    }
};

const page = (state: IWhistleBlowPageState = null, action: WhistleBlowAction) => {
    switch (action.type) {
    case WHISTLE_BLOW_SUCCESS: {
        const whistleBlowSuccess = action as IWhistleBlowSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            whistleBlowPage: whistleBlowSuccess.whistleBlowPage
        };
    }
    case WHISTLE_BLOW_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: IWhistleBlowListState = null, action: WhistleBlowAction) => {
    switch (action.type) {
    case WHISTLE_BLOW_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IWhistleBlowListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const whistleBlowReducer = combineReducers({
    page,
    list
});

//Utils
export const setWhistleBlowListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(whistleListSetDefaultFilter(defaultFilter));
};